const state = {
	sidebar: {
		opened: true,
		withoutAnimation: false
	},
	device: 'desktop',
	language: 'zh'
}

const mutations = {
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened
	},
	CLOSE_SIDEBAR: (state, withoutAnimation) => {
		state.sidebar.opened = false
		state.sidebar.withoutAnimation = withoutAnimation
	},
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},
	SET_LANGUAGE: (state, language) => {
		state.language = language
	}
}

const actions = {
	toggleSideBar({ commit }) {
		commit('TOGGLE_SIDEBAR')
	},
	closeSideBar({ commit }, { withoutAnimation }) {
		commit('CLOSE_SIDEBAR', withoutAnimation)
	},
	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device)
	},
	setLanguage({ commit }, language) {
		commit('SET_LANGUAGE', language)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
